import { api } from './client.js';

// Core API helpers. All endpoints are protected (JWT) and makler-scoped, so
// they talk to /api/v1/core/*. The client.js interceptor attaches the token.

// Activities.
export function listActivities(query = {}) {
  return api.get('/core/activities', { params: query }).then((r) => r.data.data);
}

export async function listAllActivities() {
  const activities = [];
  let cursor = 0;
  while (true) {
    const page = await listActivities({ cursor, limit: 100 });
    if (!Array.isArray(page)) throw new Error('Neplatná odpověď se seznamem aktivit.');
    activities.push(...page);
    if (page.length < 100) return activities;
    const next = Number(page.at(-1).id);
    if (!Number.isSafeInteger(next) || next <= 0 || (cursor !== 0 && next >= cursor)) {
      throw new Error('Neplatné stránkování aktivit.');
    }
    cursor = next;
  }
}

export function createActivity(payload) {
  return api.post('/core/activities', payload).then((r) => r.data.data);
}

export function updateActivity(id, payload) {
  return api.patch(`/core/activities/${id}`, payload).then((r) => r.data.data);
}

export function deleteActivity(id) {
  return api.delete(`/core/activities/${id}`).then((r) => r.data.data);
}

export function saveDailyEntry(date) {
  return api.put(`/core/daily-entries/${date}`).then((r) => r.data.data);
}

// Weekly plan (goals).
export function getProgress() {
  return api.get('/core/progress').then((r) => r.data.data);
}

export function getWeeklyPlan() {
  return api.get('/core/weekly-plan').then((r) => r.data.data);
}

export function updatePlanCompletion({ completed, goal }) {
  return api
    .patch('/core/weekly-plan/complete', { completed, goal })
    .then((r) => r.data.data);
}

export function closeWeeklyPlan() {
  return api.post('/core/weekly-plan/close').then((r) => r.data.data);
}
